import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getFileCategoryList = async () => {
  return axios.get(`${api_base_url}/GetFileCategory`).then((res) => {
    return res;
  });
};

export const addFileCategory = async (newFileCategory) => {
  const { data } = await axios.post(`${api_base_url}/AddFileCategory`, {
    ...newFileCategory,
  });
  return data;
};

export const deleteFileCategory = async (ids) => {
  const { data } = await axios.delete(
    `${api_base_url}/DeactivateFileCategory`,
    {
      data: ids,
    }
  );
  return data;
};

export const updateFileCategory = async (editFileCategory) => {
  const { data } = await axios.put(
    `${api_base_url}/EditFileCategory`,
    editFileCategory
  );
  return data;
};
